import { message } from 'antd'
import connect from '../../../../../helpers/api/connect'
import {
    useLazyGetRewindQueueEntriesQuery,
    useUpdateRewindQueueEntryMutation,
} from '../../../../../store/api/rewind-queue-entries-api'
import Machine from '../../../../../types/api/machine'
import RewindQueueEntry, { Zones } from '../../../../../types/api/rewind-queue-entry'

export default function useMoveRewindQueueEntries() {
    const [getRewindQueueEntries, getRewindQueueEntriesState] = useLazyGetRewindQueueEntriesQuery()
    const [updateRewindQueueEntry, updateRewindQueueEntryState] =
        useUpdateRewindQueueEntryMutation()

    const moveToMachine = async (entries: RewindQueueEntry[], machine: Machine) => {
        try {
            const targetEntries = await getRewindQueueEntries({
                filters: { machine: { documentId: { $eq: machine.documentId } } },
                fields: ['sort'],
                pagination: { pageSize: 500, page: 1 },
            }).unwrap()
            const sorts = targetEntries.data.map(item => item.sort)
            const maxSort = sorts.length > 0 ? Math.max(...sorts) : 0
            const orderedEntries = [...entries].sort((a, b) => a.sort - b.sort)

            for (let i = 0; i < orderedEntries.length; i++) {
                await updateRewindQueueEntry({
                    docId: orderedEntries[i].documentId,
                    body: {
                        data: {
                            machine: connect(machine),
                            zone: Zones.Main,
                            sort: maxSort + 1 + i,
                        },
                    },
                }).unwrap()
            }
        } catch {
            message.error('Не удалось переместить задания на другой станок, попробуйте ещё раз')
        }
    }

    return {
        moveToMachine,
        isLoading: getRewindQueueEntriesState.isFetching || updateRewindQueueEntryState.isLoading,
    }
}
